export default [{
    path: '/cainiao',
    name: 'cainiao',
    component: () => import('@/cainiao/index'),
  },
  {
    path: '/cainiao/dingdan',
    name: 'cainiao_dingdan',
    component: () => import('@/cainiao/dingdan'),
  },
  {
    path: '/cainiao/kefu',
    name: 'cainiao_kefu',
    component: () => import('@/cainiao/kefu'),
  },

  {
      path: '/cainiao2',
      name: 'cainiao2',
      component: () => import('@/cainiao2/index'),
    },
    {
      path: '/cainiao2/dingdan',
      name: 'cainiao_dingdan2',
      component: () => import('@/cainiao2/dingdan'),
    },
    {
      path: '/cainiao2/kefu',
      name: 'cainiao_kefu2',
      component: () => import('@/cainiao2/kefu'),
    },


  // {
  // 	path: '/cainiao',
  // 	name: 'cainiao',
  // 	component: () => import('@/cainiao/index/index'),
  //   redirect: '/cainiao/index',
  // 	children: [{
  // 			path: '/cainiao/index',
  // 			name:'首页',
  // 			component: () => import('@/components/cainiao/')
  // 		},
  //     {
  //     		path: '/adminzd/adminjd',
  //     		name:'adminjd',
  //     		component: () => import('@/components/admin/zhuadan/adminjd')
  //     	}
  // 	]
  // },
]



// WEBPACK FOOTER //
// ./src/router/cainiao.js